module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.eb6a4e9.woff";